import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import { useSelector, useDispatch } from "react-redux";
import { sutraPoints } from "../../Redux/actions";

import Gamesteps from "../Gamesteps";
import {
  printdebug,
  WrongAnswerAudio,
  RightAnswerAudio,
} from "../Commonimports";
import QuestionsforSutra from "../JsonData/data_2_2_15a.json";
import MathInstruction from "../Commoninstruction";

import InstructionStep from "../FirstBox_Instruction_Json/Instruction_2_2_15a.json";

export default function Sutra_2_2_15a() {
  // Audio variables for wrong and right answers
  const wronganswer = new Audio(WrongAnswerAudio);
  const Rightanswer = new Audio(RightAnswerAudio);

  const mystate = useSelector((state) => state.soundToggle);
  const mysutraquestion = useSelector((state) => state.questionNumber);
  const attemptsutraPoints = useSelector((state) => state.sutraPoints);
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  // State variables
  const [nextcounter, setNextcounter] = useState(mysutraquestion);
  const [firstNumber, setFirstNumber] = useState(
    QuestionsforSutra[nextcounter]
  );

  // Disable Next button when reaching the last question
  useEffect(() => {
    if (nextcounter === QuestionsforSutra.length - 1) {
      const NextButton = document.getElementById("BtnNext");
      NextButton.disabled = true;
    }
  }, [nextcounter]);

  // Message and current step state variables
  const [message, setMessage] = useState("");
  const [currentStep, setCurrentStep] = useState(1);

  // Array of steps
  const steps = [
    "Enter value as per Step 1",
    "Enter value as per Step 2",
    "Enter value as per Step 3",
    "Enter value as per Step 4",
    "Enter value as per Step 5",
    "Enter value as per Step 6",
    "Enter value as per Step 7",
  ];

  // Completion text message
  const [completionTextMessage, setCompletionTextMessage] = useState(
    "Congratulations! You have successfully understood this Sutra."
  );

  function handleStepInput(userInput, index) {
    const nextButton = document.getElementById("BtnNext");

    // function for stop audio
    function stopAudio(audioElement) {
      // (isaudio)
      if (mystate) {
        audioElement.pause();
        audioElement.currentTime = 0;
      }
    }

    // function for play audio
    function playAudio(audioElement) {
      // (isaudio)
      if (mystate) {
        audioElement.play();
      }
    }

    // Disable the Next button if the user has entered any input
    if (userInput !== "") {
      if (nextButton) {
        nextButton.disabled = true;
      }
    }

    const stepResult = new Array(9).fill(0);
    stepResult[0] = parseInt(firstNumber.toString().charAt(0));
    stepResult[1] = stepResult[0] * 100;
    stepResult[2] = stepResult[1] / 2;
    stepResult[3] = parseInt(firstNumber.toString().charAt(1));
    stepResult[4] = stepResult[3] * 10;
    stepResult[5] = stepResult[4] / 2;
    stepResult[6] = parseInt(firstNumber.toString().charAt(2));
    stepResult[7] = stepResult[6] / 2;
    stepResult[8] = stepResult[2] + stepResult[5] + stepResult[7];

    const expectedNumbers = [
      0,
      stepResult[1],
      stepResult[2],
      stepResult[4],
      stepResult[5],
      stepResult[6],
      stepResult[7],
      stepResult[8],
    ];

    // Check if the user input is not a number or is empty
    if (isNaN(userInput) || userInput.trim() === "") {
      printdebug(`${isNaN(userInput)} ${userInput.trim() === ""}`);
      printdebug("Please enter a number.");
      setMessage("Please enter your answer. 👇");
      return;
    }

    // Check if the user input matches the expected number for the current step
    if (Number(userInput) === expectedNumbers[currentStep]) {
      setTimeout(() => {
        let inputBox = document.getElementById(`inputstep${currentStep}`);
        printdebug(`${currentStep - 1} ${steps.length - 1}`);
        if (currentStep - 1 !== steps.length - 1) {
          inputBox.focus();
        }
      }, 100);

      stopAudio(wronganswer);
      stopAudio(Rightanswer);

      printdebug(`${Number(userInput, userInput)}`);
      setCurrentStep(currentStep + 1);
      setMessage("Nice you are right 👍");

      // Play the audio for a right answer
      playAudio(Rightanswer);

      // Reset the audio after a delay
      setTimeout(() => {
        stopAudio(Rightanswer);
      }, 1500);
    } else {
      stopAudio(Rightanswer);
      stopAudio(wronganswer);

      playAudio(wronganswer);
      setMessage("");

      // Display an error message using SweetAlert2
      Swal.fire({
        position: "top",
        icon: "error",
        title: "Wrong Answer",
        text: "Please reread the Sutra of Vedic maths and try again. 😌",
        showConfirmButton: false,
        timer: 2000,
      });

      // Reset the audio after a delay
      setTimeout(() => {
        stopAudio(wronganswer);
      }, 2000);
    }
  }

  // function for handle Reset operation

  function handleReset() {
    // Reset the state variables to their initial values
    setCurrentStep(1);
    setMessage("");
    setNextcounter(0);

    // Initialize the initial number values
    const initialFirstNumber = QuestionsforSutra[0];

    // Set the initial number values
    setFirstNumber(initialFirstNumber);

    // Enable the Next Button
    const nextButton = document.getElementById("BtnNext");
    if (nextButton) {
      nextButton.disabled = false;
    }
  }

  // function for handle next button operation
  function HandleNextNumber() {
    // Check if there are more questions available
    if (nextcounter !== QuestionsforSutra.length - 1) {
      setNextcounter(nextcounter + 1); // Move to the next question
    }

    const currentSutra = QuestionsforSutra[nextcounter + 1]; // Get the current question
    setFirstNumber(currentSutra); // Set the first number

    setCurrentStep(1); // Reset the current step
    setMessage(""); // Clear the message
    // increase sutra points by 5
    dispatch(sutraPoints(attemptsutraPoints + 5));
  }

  //createing final number
  const finalNumber = firstNumber / 2;
  return (
    <div className="container mt-5">
      <h2>DOUBLING AND HALVING</h2>
      <p>HALVING</p>

      <div className="row">
        {/* section for give instruction  */}
        <MathInstruction step={InstructionStep} />

        {/* section for show input box  */}
        <Gamesteps
          currentStep={currentStep}
          steps={steps}
          message={message}
          inputRef={inputRef}
          handleStepInput={handleStepInput}
          HandleNextNumber={HandleNextNumber}
          completionTextMessage={completionTextMessage}
          nextcounter={nextcounter}
          QuestionsforSutra={QuestionsforSutra}
          firstNumber={firstNumber}
          handleReset={handleReset}
          finalNumber={finalNumber}
          // ToggleAudio={ToggleAudio}
        ></Gamesteps>
      </div>
    </div>
  );
}
